import axios from "axios";

export function getActionLogs(params) {
  return axios.get("/partner/api/v1/action-logs", { params });
}
